import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "@/store/userSlice";

declare global {
  interface Window {
    june: any;
    juneify: any;
    analytics: any;
  }
}

interface JuneAnalyticsProps {
  writeKey: string;
}

export const trackEvent = (
  eventName: string,
  properties?: Record<string, any>
) => {
  if (window.analytics && window.analytics.track) {
    window.analytics.track(eventName, {
      event: eventName,
      ...properties,
    });
    console.log("June trackEvent", eventName, properties);
  }
};

const JuneAnalytics: React.FC<JuneAnalyticsProps> = ({ writeKey }) => {
  const user = useSelector(selectUser);

  useEffect(() => {
    window.analytics = {};
    const juneify = (writeKey: string) => {
      console.log("Initializing June Analytics..."); // Log inizializzazione
      window.analytics._writeKey = writeKey;
      const script = document.createElement("script");
      script.type = "application/javascript";
      script.onload = function () {
        console.log("June script loaded successfully"); // Log successo caricamento
        window.analytics.debug(true);

        // Identifica l'utente se disponibile
        if (user?._id) {
          window.analytics.identify(user._id, {
            email: user.email,
            name: user.firstName,
          });
        }

        // Configurazione esplicita del dominio
        window.analytics.track("june_initialized", {
          domain: window.location.hostname,
          environment: "development",
          timestamp: new Date().toISOString(),
          app: "takyon-dashboard",
          version: "3.0",
        });

        // Track page view con dettagli aggiuntivi
        window.analytics.page({
          domain: window.location.hostname,
          path: window.location.pathname,
          url: window.location.href,
          title: document.title,
          environment: "development",
          app: "takyon-dashboard",
        });

        console.log("June Analytics initialized with key:", writeKey);
        console.log("Test events sent to June Analytics");
      };
      script.onerror = function (error) {
        console.error("Error loading June script:", error); // Log errori
      };
      script.src =
        "https://unpkg.com/@june-so/analytics-next/dist/umd/standalone.js";
      const first = document.getElementsByTagName("script")[0];
      if (first && first.parentNode) {
        first.parentNode.insertBefore(script, first);
      } else {
        document.head.appendChild(script);
      }
    };
    juneify(writeKey);
  }, [writeKey, user]);

  return null;
};

export default JuneAnalytics;
